import React from 'react';

/**
 * Public page used to confirm ownership of volgly.net for Revolut compliance.
 * It contains a short project description, business activities, and owner details.
 * Accessible at /info
 */
const RevolutVerification = () => (
  <main
    style={{
      background: '#fff',          // full‑black backdrop to match landing
      color: '#000',               // white text
      minHeight: '100vh',          // fill viewport vertically
      padding: '4rem 1rem',        // generous breathing space
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <div style={{ width: '100%', maxWidth: '800px', fontSize: '0.95rem' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '3rem', fontSize: '2rem', fontWeight: 700 }}>
        Project&nbsp;&amp;&nbsp;Ownership&nbsp;Statement
      </h1>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>About&nbsp;VaultGrid</h2>
        <p><strong>VaultGrid</strong> is a project launched in Bratislava in 2025.</p>
        <p>It is currently in the community‑building phase.</p>
        <p>The core idea of VaultGrid is to support easy and natural socialization by:</p>
        <ul style={{ marginLeft: '1.5rem', listStyleType: 'disc' }}>
          <li>Organizing events for and by community members 🎉</li>
          <li>Linking a person’s virtual identity with their real‑life presence 🌍</li>
        </ul>
        <p style={{ marginTop: '1rem' }}>
          The project aims to break down the initial communication barriers between
          people and make new connections more accessible. 🌟
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Business&nbsp;Activities</h2>
        <ul style={{ marginLeft: '1.5rem', listStyleType: 'disc' }}>
          <li>Subscription plans for users who want advanced platform features.</li>
          <li>Commercial subscriptions for businesses hosting events on the platform.</li>
          <li>Sale of official VaultGrid merchandise.</li>
          <li>User donations for acquiring skins and customization items.</li>
        </ul>
      </section>

      <section>
        <h2 style={{ marginBottom: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Developer&nbsp;&amp;&nbsp;Owner</h2>
        <p><strong>Aleksandr&nbsp;Okunev</strong></p>
        <address style={{ fontStyle: 'normal' }}>
          Zamocka&nbsp;732724, 811 01 Bratislava‑Stare Mesto, Slovakia
        </address>
        <p style={{ marginTop: '0.5rem' }}>
          Phone:&nbsp;+421‑950‑371‑603
        </p>
        <p>
          Email:&nbsp;
          <a href="mailto:okunev686@gmail.com" style={{ color: 'inherit', textDecoration: 'underline' }}>
            okunev686@gmail.com
          </a>
        </p>
      </section>
    </div>
  </main>
);

export default RevolutVerification;
